<template>
	<div>
		<div id="business" class="container-fluid">
			<div class="subtitle">Business Cooperation</div>
			<el-form ref="form" :model="form" :rules="rules">
				<el-row :gutter="40">
					<el-col :span="12">
						<el-form-item prop="userName">
							<el-input v-model="form.userName" placeholder="Your name" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="companyName">
							<el-input v-model="form.companyName" placeholder="Your e-mail address" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item prop="content">
							<el-input v-model="form.content" placeholder="Your demands" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item>
							<el-button :loading="submit" @click="submitForm">Submit Now</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div id="footer">
			<el-row>
				<el-col :xs="24" :sm="12">
					<div class="left">
						<div class="logo">
							<img src="@/assets/img/logo_white.png" alt="logo">
						</div>
						<div>Colofoo Technology is committed to building smart wearable cardiovascular digital experts for health industry customers. Co-Health digital platform supports Huawei's heart health research program and 301 Hospital's mAFA platform,and integrated solutions for smart wearable device technology,, heart health data, artificial intelligence health risk management, personalized health intervention open platform capabilities, and digital medical systems, etc.
						</div>
						<div>ADDRESS</div>
						<div>601-8 Rujun Building, No. 105 Zhongxing Road, Ma 'an Tang Community, Bantian Street, Longgang District, Shenzhen</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="12">
					<div class="right">
						<div>GET IN TOUCH</div>
						<div>
							<div>Email</div>
							<div>business@colofoo.com</div>
						</div>
						<div>
							<div>Call</div>
							<div>+086 181-3877-5666</div>
						</div>
						<div>
							<img src="@/assets/images/contact1.png" />
							<img src="@/assets/images/contact2.png" />
							<img src="@/assets/images/contact3.png" />
							<img src="@/assets/images/contact4.png" />
						</div>
					</div>
				</el-col>
				<el-col :span="24">
					<div class="bottom">
						<div>© Copyright 2020 All Rights Reserved Co-health</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import {contact} from "../api/api";
export default {
	name: "Footer",
	data() {
		return {
			submit: false,
			form: {
				userName: '',
				companyName: '',
				content: '',
				position: '',
				phone: ''
			},
			rules: {
				userName: [
					{ required: true, message: 'Your name is required', trigger: 'blur' }
				],
				companyName: [
					{ required: true, message: 'Your email is required', trigger: 'blur' }
				],
				content: [
					{ required: true, message: 'Your demands is required', trigger: 'blur' }
				],
			}
		}
	},

	methods: {
		submitForm() {
			let that = this
			let form = that.form

			that.$gtag.event('event',  {
				send_to: 'AW-11312925889/e_gaCID6vdoYEMGZtpIq'
			})

			this.$refs['form'].validate(valid => {
				if (valid) {
					that.submit = true

					contact(form).then(res => {
						if(res.code === 200) {
							that.form = {
								userName: '',
								companyName: '',
								content: '',
								position: '',
								phone: ''
							}
							that.$message.success('Successfully')
						}else{
							that.$message.error('Failed')
						}
					}).finally(() => {
						that.submit = false
					})
				}
			})
		}
	}
};
</script>
<style lang="less" scoped>
#business{
	padding: 4.13rem 7.44rem;
	background: url("../assets/images/img_bg4.jpg") center center no-repeat;
	background-size: cover;
	.subtitle{
		font-size: 48px;
		color: #FFFFFF;
		line-height: 62px;
		text-align: center;
	}
	.el-form{
		padding: 20px 20%;
		.el-button{
			margin: 0 auto;
			display: flex;
			background: linear-gradient(125deg, #430DFF 0%, #8D3EFF 100%);
			border-radius: 8px;
			border: 0;
			font-size: 24px;
			font-weight: 400;
			color: #FFFFFF;
			padding: 20px 50px;
		}
	}
}
/deep/.el-input__inner{
	background: rgba(1,14,43,0.75);
	border-radius: 5px;
	border: 1px solid #8393ED;
	backdrop-filter: blur(4px);
	padding: 27px;
	color: #FFFFFF;
}
#footer {
	color: #fff;
	background: #0E1739;
	.left,.right{
		padding: 3.44rem 7.44rem;
	}
	.left{
		.logo img{
			width: 15.56rem;
		}
		div:nth-child(2){
			margin-top: 1.19rem;
			font-size: 0.88rem;
			font-weight: 300;
			color: rgba(255, 255, 255, 0.7);
			line-height: 1.25rem;
		}
		div:nth-child(3){
			margin-top: 1.25rem;
			font-size: 1.25rem;
			font-weight: 500;
			color: #FFFFFF;
			line-height: 1.75rem;
		}
		div:nth-child(4){
			margin-top: 0.63rem;
			font-size: 0.75rem;
			font-weight: 400;
			color: rgba(255, 255, 255, 0.7);
			line-height: 1.06rem;
		}
	}
	.right{
		>div:nth-child(1){
			font-size: 1.25rem;
			font-weight: 500;
			color: #FFFFFF;
			line-height: 1.75rem;
		}
		>div:nth-child(2){
			margin-top: 1.88rem;
		}
		>div:nth-child(3){
			margin-top: 1.25rem;
		}
		>div:nth-child(2),>div:nth-child(3){
			div:nth-child(1){
				font-size: 0.88rem;
				font-weight: 300;
				color: rgba(255, 255, 255, 0.7);
				line-height: 1.25rem;
			}
			div:nth-child(2){
				margin-top: 0.38rem;
				font-size: 1rem;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 1.38rem;
			}
		}
		>div:nth-child(4){
			margin-top: 1.25rem;
			display: flex;
			img{
				width: 3.19rem;
				margin-right: 0.56rem;
				cursor: pointer;
			}
		}
	}
	.bottom{
		padding: 1.19rem 0;
		font-size: 0.81rem;
		background: #0E1739;
		box-shadow: inset 0 0.06rem 0 0 rgba(255,255,255,0.1);
		font-weight: 400;
		color: rgba(255, 255, 255, 0.7);
		line-height: 1.13rem;
		text-align: center;
		div:nth-child(2){
			margin-top: 0.38rem;
		}
	}
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
	#footer {
		.left,.right{
			padding: 2rem 5rem;
		}
		.left{
			div:nth-child(2),div:nth-child(4){
				font-size: 1rem;
				line-height: 1.8rem;
			}
		}
		.right{
			>div:nth-child(2),>div:nth-child(3){
				div:nth-child(1){
					font-size: 1rem;
					line-height: 1.25rem;
				}
				div:nth-child(2){
					margin-top: 0.5rem;
					font-size: 1.5rem;
					line-height: 1.38rem;
				}
			}
			>div:nth-child(4){
				margin-top: 1.5rem;
				img{
					width: 4rem;
				}
			}
		}
		.bottom{
			padding: 2rem;
			div:nth-child(2){
				margin-top: 1rem;
			}
		}
	}
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {

}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue